import React from 'react'

import { Field as FinalFormField } from 'react-final-form'

import Error from './index.presentational'
import { ContainerProps } from './types'

const ErrorContainer: React.FC<ContainerProps> = ({
  alwaysShowError = false,
  children,
  delay = 1000,
  name = '',
  touched: touchedProp = undefined,
}): React.ReactElement =>
  React.createElement(
    FinalFormField,
    {
      name,
      subscription: {
        active: true,
        dirty: true,
        touched: true,
      },
    },
    ({
      meta: {
        active,
        dirty,
        touched,
      },
    }: {
      meta: {
        active: boolean,
        dirty: boolean,
        touched: boolean,
      },
    }) =>
      React.createElement(
        Error,
        {
          active,
          alwaysShowError,
          delay,
          dirty,
          touched: touchedProp || touched,
        },
        children,
      ),
  )

export * from './types'

export default ErrorContainer
